"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundDateTimeMinutes = void 0;
const moment_mini_1 = __importDefault(require("moment-mini"));
// Converts date string to date with rounded minutes (0/30)
function roundDateTimeMinutes(dateStr) {
    const momentDate = moment_mini_1.default.utc(dateStr);
    const minutes = Math.floor(momentDate.minute() / 30) * 30;
    return momentDate
        .startOf('hour')
        .add(minutes, 'minutes')
        .format();
}
exports.roundDateTimeMinutes = roundDateTimeMinutes;
